export default "__VITE_ASSET__bu8vgW$B__"